import React, { Component } from "react";
import { Field } from "formik";
import { Stepper } from "react-form-stepper";
import { connect } from "react-redux";
import style from "./BankDetails.module.css";
import Dropdown from "../../../utils/Dropdown.json";
import Country from "../../../utils/country.json";
import { fetchDropdownList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";

export class BankDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScreenLoaded: false,
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  };

  goBackStep1 = () => {
    this.props.navigateBackStep1();
  };

  goBack = (index) => {
    this.props.navigateBack();
  };

  goNext = () => {
    this.props.navigateNext();
  };

  render() {
    // getting dropdown list options from redux persist
    const dropdownData = this.props.dropdownListData.dropdownList;

    const accTypeOptions = dropdownData.lk_account_type.map(
      (element, index) => (
        <option key={index} value={element.lk_account_type_id}>
          {element.account_type}
        </option>
      )
    );

    const bankListOptions = dropdownData.lk_bank_list.map((element, index) => (
      <option key={index} value={element.lk_bank_id}>
        {element.bank_name}
      </option>
    ));

    const countryListOptions = dropdownData.country.map((element, index) => (
      <option key={index} value={element.country_id}>
        {element.name}
      </option>
    ));

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className={style.bankMainWrapper}>
          <div className={style.headingWrapper}>
            <h2>Step 3 : Contact Creation - Bank Details</h2>
            <p>
            Capture the banking details of the Contact. 
            This section is optional but it's advisable to complete it for Professional Service Providers and Suppliers.
            </p>
            <hr />
          </div>
          <div className="row">
            <div className="col-md-10 col-xl-6">
              <div className="custom-stepper">
                <div className={style.stepperWrapper}>
                  <div className="custom-stepper">
                    <ul>
                      <li>
                        <h3 onClick={this.goBackStep1}>1</h3>
                      </li>
                      <li>
                        <h3 onClick={this.goBack}>2</h3>
                      </li>
                      <li>
                        <h3 className="active">3</h3>
                      </li>
                      <li>
                        <h3 onClick={this.goNext}>4</h3>
                      </li>
                    </ul>
                  </div>
                  {/* <div className="custom-stepper">
                    <div className={style.stepperWrapper}>
                      <Stepper
                        steps={[
                          { label: "" },
                          { label: "" },
                          { label: "" },
                          { label: "" },
                        ]}
                        activeStep={0}
                        styleConfig={{
                          inactiveBgColor: "#fff",
                          activeBgColor: "#00467F",
                          inactiveTextColor: "#00467F",
                          activeTextColor: "#fff",
                          completedBgColor: "#fff",
                          completedTextColor: "#00467F",
                        }}
                        connectorStyleConfig={{
                          disabledColor: "#00467F33 ",
                          size: 2,
                        }}
                      />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className={`form-controls-wrapper ${style.bankFormWrapper}`}>
            <h4>Enter the Banking Details :</h4>
            <div className="row form-group">
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label htmlFor="accNameHolder">
                  Account Holder Name 
                </label>
                <Field
                  name="accNameHolder"
                  placeholder="Account Name Holder"
                  maxLength="20"
                  value={this.props.values.accNameHolder}
                  onChange={this.props.handleChange}
                  className={
                    "form-control" +
                    (this.props.errors.accNameHolder &&
                    this.props.touched.accNameHolder
                      ? " is-invalid"
                      : "")
                  }
                />
                {this.props.errors.accNameHolder &&
                this.props.touched.accNameHolder ? (
                  <div className={style.errMsg}>
                    {this.props.errors.accNameHolder}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label htmlFor="bank">
                  Bank
                </label>
                <Field
                  name="bank"
                  as="select"
                  placeholder="Select Title"
                  maxLength="20"
                  onChange={this.props.handleChange}
                  className={
                    "form-control" +
                    (this.props.errors.bank && this.props.touched.bank
                      ? " is-invalid"
                      : "")
                  }
                >
                  <option value="">Select bank</option>
                  {bankListOptions}
                </Field>
                {this.props.errors.bank && this.props.touched.bank ? (
                  <div className={style.errMsg}>{this.props.errors.bank}</div>
                ) : null}
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label htmlFor="accNumber">
                  Account Number 
                </label>
                <Field
                  name="accNumber"
                  placeholder="Account Number"
                  value={this.props.values.accNumber}
                  onChange={this.props.handleChange}
                  maxLength="20"
                  className={
                    "form-control" +
                    (this.props.errors.accNumber && this.props.touched.accNumber
                      ? " is-invalid"
                      : "")
                  }
                />
                {this.props.errors.accNumber && this.props.touched.accNumber ? (
                  <div className={style.errMsg}>
                    {this.props.errors.accNumber}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label htmlFor="accType">
                  Account Type 
                </label>
                <Field
                  name="accType"
                  as="select"
                  placeholder="Account Type"
                  value={this.props.values.accType}
                  onChange={this.props.handleChange}
                  className={
                    "form-control" +
                    (this.props.errors.accType && this.props.touched.accType
                      ? " is-invalid"
                      : "")
                  }
                >
                  <option value="">Select Account Type</option>
                  {accTypeOptions}
                </Field>
                {this.props.errors.accType && this.props.touched.accType ? (
                  <div className={style.errMsg}>
                    {this.props.errors.accType}
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label htmlFor="branchCode">
                  Branch Code 
                </label>
                <Field
                  name="branchCode"
                  placeholder="Branch Code"
                  value={this.props.values.branchCode}
                  maxLength="20"
                  onChange={this.props.handleChange}
                  className={
                    "form-control" +
                    (this.props.errors.branchCode &&
                    this.props.touched.branchCode
                      ? " is-invalid"
                      : "")
                  }
                />
                {this.props.errors.branchCode &&
                this.props.touched.branchCode ? (
                  <div className={style.errMsg}>
                    {this.props.errors.branchCode}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label htmlFor="country">
                  Country 
                </label>
                <Field
                  name="country"
                  as="select"
                  placeholder="Select Country"
                  maxLength="20"
                  onChange={this.props.handleChange}
                  className={
                    "form-control" +
                    (this.props.errors.country && this.props.touched.country
                      ? " is-invalid"
                      : "")
                  }
                >
                  <option value="">Select Country</option>
                  {countryListOptions}
                </Field>
                {this.props.errors.country && this.props.touched.country ? (
                  <div className={style.errMsg}>
                    {this.props.errors.country}
                  </div>
                ) : null}
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label htmlFor="swiftCode">SWIFT/BIC Code</label>
                <Field
                  name="swiftCode"
                  placeholder="SWIFT/BIC Code"
                  maxLength="20"
                  value={this.props.values.swiftCode}
                  onChange={this.props.handleChange}
                  className={
                    "form-control" +
                    (this.props.errors.swiftCode && this.props.touched.swiftCode
                      ? " is-invalid"
                      : "")
                  }
                />
                {this.props.errors.swiftCode && this.props.touched.swiftCode ? (
                  <div className={style.errMsg}>
                    {this.props.errors.swiftCode}
                  </div>
                ) : null}
              </div>
            </div>
            <hr className={style.formBottomLine} />
            {Object.keys(this.props.errors).length > 0 &&
              this.state.nextClicked && (
                <div className="text-danger">
                  Please fill all mandatory fields!
                </div>
              )}
            <div
              className={` d-flex
              justify-content-between
              flex-column-reverse
              flex-md-row
              align-items-center ${style.btnWrapper}`}
            >
              <button
                type="button"
                className="btn form-primary-btn mb-3"
                onClick={this.props.navigateBack}
              >
                Back
              </button>
              {/* <button type="submit" className="btn form-primary-btn">
                Submit
              </button> */}
              <button
                type="button"
                className="btn form-primary-btn  mb-3"
                onClick={() => {
                  this.props.navigateNext();
                  this.setState({ nextClicked: true });
                }}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BankDetails);
